/* eslint react/jsx-props-no-spreading: 0 */

import React from 'react';
import ReactRouterPropTypes from 'react-router-prop-types';
import {
  View,
  Text,
  ActivityIndicator,
  Platform,
} from 'react-native';
import AsyncStorage from '@react-native-async-storage/async-storage';
// import { withAuthenticator } from '@aws-amplify/ui-react';
import { getCurrentUser, fetchUserAttributes, fetchAuthSession } from '@aws-amplify/auth';
// import { listenToAuthHub } from '@aws-amplify/ui';
// import { Auth, Hub } from '@aws-amplify/auth';
// import Auth from '@aws-amplify/auth';
import { Hub } from 'aws-amplify/utils';
import { createMachine, interpret } from '@xstate/fsm';
import InAppBrowser from '../../browser'; // eslint-disable-line import/named

import styles from '../../styles';
import { translate } from '../../locales/i18n';

// import AmplifyConfig from '../../backends/AmplifyConfig';
// import { Amplify } from 'aws-amplify';

// Amplify.configure(AmplifyConfig);

export const AuthContext = React.createContext({
});

// export function withAuthContext(Component) {
//   return (props) => (
//     <AuthContext.Consumer>
//       {(context) => <Component {...props} authContext={context} /> /* eslint-disable-line react/jsx-props-no-spreading */}
//     </AuthContext.Consumer>
//   );
// }

// const withAuthentication = (Comp) => withAuthenticator(({ signOut, user }) => class WithOAuth extends React.Component {
//   static propTypes = { // eslint-disable-line react/static-property-placement
//     history: ReactRouterPropTypes.history.isRequired,
//   };

//   constructor(props, context) {
//     super(props, context);

//     this.authContext = {
//       signOut,
//       user,
//     };

//     this.state = {
//       user: user,
//       userHash: '---',
//       userIdentity: '---',
//     };

//     this.authContext = {
//       state: this.state,
//     };
//   }

//   // componentDidMount() {
//   //   const { history } = this.props;
//   // }

//   render() {
//     const { user, userHash, userIdentity } = this.state;

//     return (
//       <AuthContext.Provider value={this.authContext}>
//         <Comp {...this.props} user={user} userHash={userHash} userIdentity={userIdentity} />
//       </AuthContext.Provider>
//     );
//   }
// });

export default (Comp) => class Authentication extends React.Component {
  static propTypes = {
    history: ReactRouterPropTypes.history.isRequired,
  };

  constructor(props, context) {
    super(props, context);

    const { history } = this.props;

    this.state = {
      user: null,
      userHash: '---',
      userIdentity: '---',
    };

    this.setState = this.setState.bind(this);
    const getState = () => this.state;
    const setState = (newState, callback) => this.setState(newState, callback);

    const authStates = createMachine({
      // function getAuthMachine(getState, setState) {
      // const fsm = interpret(createMachine({
      id: 'auth',
      initial: 'AUTHENTICATING',
      context: {
        isContext: true,
      },
      states: {
        AUTHENTICATING: {
          entry: (ctx) => {
            console.log('AUTHENTICATING entry');
            console.log(ctx);
            const { userIdentity } = getState();

            try {
              // Use 'currentCredentials' before 'currentAuthenticatedUser' in order to
              // get the hash of the unauthenticated user.
              fetchAuthSession()
                .then(({ tokens, credentials, identityId }) => {
                  // if (!tokens || !credentials || !identityId) {
                  //   setState(
                  //     {
                  //       user: null,
                  //       userHash: '---',
                  //       userIdentity: '---',
                  //     },
                  //     () => this.authContext.fsm.send('AUTH_FAIL')
                  //   );
                  //   return;
                  // }

                  console.log('tokens');
                  console.log(tokens);
                  console.log('credentials');
                  console.log(credentials);
                  console.log('identityId');
                  console.log(identityId);

                  if (identityId && identityId !== userIdentity) {
                    if (tokens) {
                      const user = tokens.accessToken.payload.username;

                      fetchUserAttributes().then((attributes) => {
                        console.log('attributes');
                        console.log(attributes);
                        setState({
                          user: {
                            attributes: {
                              ...attributes,
                              preferred_username: attributes.preferred_username || user,
                              uuid: attributes.sub,
                            },
                            username: user,
                          },
                          userIdentity: identityId,
                          userHash: identityId.substring(identityId.length - 3).toUpperCase(),
                        }, () => {
                          console.log('Sending AUTH_OK');
                          this.authContext.fsm.send('AUTH_OK');
                        });
                      }).catch((err) => {
                        console.log('fetchUserAttributes() failed.');
                        console.log(err);

                        setState({
                          user: undefined, // null?
                          userIdentity: identityId,
                          userHash: identityId.substring(identityId.length - 3).toUpperCase(),
                        });
                      });
                    } else {
                      setState({
                        user: undefined, // null?
                        userIdentity: identityId,
                        userHash: identityId.substring(identityId.length - 3).toUpperCase(),
                      });
                    }
                  }
                })
                .catch((err) => {
                  console.log('signIn() failed.');
                  console.log(err);
                  console.log(typeof err);

                  let conclusiveError = false;
                  switch (typeof err) {
                    case 'string':
                      conclusiveError = err === 'not authenticated' || err === 'No current user';
                      break;

                    case 'object':
                      console.log(Object.getOwnPropertyNames(err));
                      console.log(err.message);
                      conclusiveError = err.message.indexOf('Please authenticate') !== -1;
                      break;

                    default:
                      break;
                  }
                  setState(
                    {
                      user: null,
                      userHash: '---',
                      userIdentity: '---',
                    },
                    () => this.authContext.fsm.send(conclusiveError ? 'AUTH_FAIL' : 'AUTH_ERROR')
                  );
                });

              // getCurrentUser()
              //   .then(({ username, authFlowType }) => {
              //     console.log(this.authContext.fsm);
              //     console.log(username);
              //     console.log(authFlowType);
              //     // this.authContext.fsm.send('AUTH_OK', { user: username });
              //   })
              //   .catch((err) => {
              //     console.log('Authentication failed.');
              //     console.log(err);
              //     console.log(typeof err);

              //     let conclusiveError = false;
              //     switch (typeof err) {
              //       case 'string':
              //         conclusiveError = err === 'not authenticated' || err === 'No current user';
              //         break;

              //       case 'object':
              //         console.log(Object.getOwnPropertyNames(err));
              //         console.log(err.message);
              //         conclusiveError = err.message.indexOf('Please authenticate') !== -1;
              //         break;

              //       default:
              //         break;
              //     }
              //     setState(
              //       {
              //         user: null,
              //         userHash: '---',
              //         userIdentity: '---',
              //       },
              //       () => this.authContext.fsm.send(conclusiveError ? 'AUTH_FAIL' : 'AUTH_ERROR')
              //     );
              //     return null;
              //   });

              // fetchAuthSession()
              //   .then(({ tokens }) => {
              //     console.log('tokens');
              //     console.log(tokens);
              //   });

              Hub.listen('auth', ({ payload: { event, data } }) => {
                console.log('event');
                console.log(event);
                switch (event) {
                  case 'oAuthSignOut':
                  case 'cognitoHostedUI':
                    console.log('oauth event');
                    console.log(event);

                    if (Platform.OS !== 'web') {
                      setTimeout(() => InAppBrowser.close(), 2000); // TODO(clairbee): is this needed???
                    }
                    break;
                  case 'parsingCallbackUrl': {
                    // this happens on mobile
                    console.log('parsingCallbackUrl');
                    console.log(data);

                    const { url } = data;
                    const prefix = 'aionrails:/';
                    if (url && url.startsWith(prefix)) {
                      const page = url.substring(prefix.length);
                      history.push(page);
                    }
                    break;
                  }
                  case 'customOAuthState':
                    // this happens on web
                    console.log('customOAuthState');
                    console.log(data);

                    if (Platform.OS === 'web') {
                      try {
                        AsyncStorage.setItem('oauthState', decodeURIComponent(data));
                      } catch (error) {
                        // Error saving data
                      }
                    }
                    break;
                  case 'signedOut':
                    console.log('sign out detected');
                    setState({ user: null }, () => {
                      this.authContext.fsm.send('SIGNED_OUT');
                    });
                    break;
                  case 'signedIn':
                    console.log('sign in detected');
                    console.log(data);

                    fetchAuthSession()
                      .then(({ tokens, identityId }) => {
                        const user = tokens.accessToken.payload.username;
                        fetchUserAttributes().then((attributes) => {
                          console.log('attributes');
                          console.log(attributes);
                          setState({
                            user: {
                              attributes: {
                                ...attributes,
                                preferred_username: user,
                                uuid: attributes.sub,
                              },
                              username: user,
                            },
                            userIdentity: identityId,
                            userHash: identityId.substring(identityId.length - 3).toUpperCase(),
                          });
                        }).catch((err) => {
                          console.log('fetchUserAttributes() failed.');
                          console.log(err);
                          if (err === 'not authenticated' || (err instanceof Error && err.message.indexOf('Please authenticate') !== -1)) {
                            setState({ user: null });
                          }
                        });
                      });

                    break;
                  default:
                    console.log('HUB event');
                    console.log(event);
                    console.log(data);
                }
              });
            } catch (error) {
              console.log('auth check exception');
              console.log(error);
              // this is the same as no auth?
            }
          },
          on: {
            AUTH_OK: {
              target: 'AUTHENTICATED',
              actions: (ctx, event) => {
                console.log('authentication check ok');
                console.log(event);
                console.log(getState());
                // ctx.user = event.user;
                const { user } = getState();
                ctx.user = user;
              },
            },
            AUTH_FAIL: {
              target: 'NOT_AUTHENTICATED',
              actions: (_ctx, event) => {
                console.log('user is not authenticated');
                console.log(event);
              },
            },
            AUTH_ERROR: {
              // target: 'NOT_AUTHENTICATED',
              target: 'WAITING',
              actions: (ctx, event) => {
                console.log('error while authenticating the user');
                console.log(ctx);
                console.log(event);

                setTimeout(() => {
                  //   Auth.signOut().then(() => {
                  this.authContext.fsm.send('RETRY');
                  // });
                }, 2500);
              },
            },
          },
        },
        WAITING: {
          entry: (_ctx) => {
            console.log('WAITING entry');
            // console.log(ctx);
            // setState({ user: undefined });
          },
          on: {
            SIGNED_IN: 'AUTHENTICATING',
            RETRY: 'AUTHENTICATING',
          },
        },
        NOT_AUTHENTICATED: {
          entry: (_ctx) => {
            console.log('NOT_AUTHENTICATED entry');
            // console.log(ctx);
            setState({ user: null });
          },
          on: {
            SIGNED_IN: 'AUTHENTICATING',
            RETRY: 'AUTHENTICATING', // TODO(clairbee): is this needed?
          },
        },
        AUTHENTICATED: {
          entry: (ctx) => {
            console.log('AUTHENTICATED entry');
            console.log(ctx);
            setState({ user: ctx.user });
          },
          on: {
            RETRY: 'AUTHENTICATING',
          },
        },
        on: {
          SIGNED_OUT: 'AUTHENTICATING',
        },
      },
    });

    // return fsm;

    this.authContext = {
      fsm: interpret(authStates),
      state: this.state,
    };

    console.log('Authentication constructor');
  }

  componentDidMount() {
    console.log('componentDidMount Authentication');
    this.authContext.fsm.start();

    // try {
    //   Hub.listen('auth', ({ payload: { event, _data } }) => {
    //     switch (event) {
    //       case 'signOut':
    //         console.log('sign out detected');
    //         this.setState({ user: null });
    //         break;
    //       case 'signIn':
    //         Auth.currentAuthenticatedUser()
    //           .then((user) => {
    //             console.log(user);
    //             this.setState({ user });
    //           })
    //           .catch((err) => {
    //             console.log(err);
    //             this.setState({ user: null });
    //           });
    //         break;
    //       default:
    //         console.log('HUB event');
    //         console.log(event);
    //     }
    //   });
    // } catch (error) {
    //   console.log('auth check exception');
    //   console.log(error);
    //   // this is the same as no auth?
    // }
  }

  render() {
    const { user, userHash, userIdentity } = this.state;

    console.log('render Authentication');
    console.log(user);
    console.log(userHash);

    if (userHash === undefined || userHash === '---') {
      return (
        <View
          style={{
            flex: 1,
            justifyContent: 'center',
            alignItems: 'center',
            backgroundColor: 'white',
          }}
        >
          <Text>{translate('view_auth_check')}</Text>
          <ActivityIndicator size="large" color={styles.primaryColor} />
        </View>
      );
    }

    return (
      // <>
      // </>
      <AuthContext.Provider value={this.authContext}>
        <Comp {...this.props} user={user} userHash={userHash} userIdentity={userIdentity} />
      </AuthContext.Provider>
    );
  }
};

// Authentication.propTypes = {
//   history: ReactRouterPropTypes.history.isRequired,
// };

// const withAuthentication = (Comp) => (
//   <Authentication />

// )(Comp);

// export default { getAuthMachine };
// export default Authentication;
